export default function Style(){
  return (
    <style>
      {`
       .sr-timeline .rs-timeline-item-content {
    margin-left: 24px;
}

.sr-timeline .rs-timeline-item-content .date {
    font-weight: 700;
}

.sr-timeline .rs-timeline-item-content .text {
    margin: 0;
    font-size: 13px
}

.sr-timeline .rs-timeline-item-content .action {
    padding: 0;
}

.sr-timeline {
    margin-left: 20px;
}

.sr-timeline .rs-timeline-item-custom-dot .rs-icon {
    position: absolute;
    background: #fff;
    top: 0;
    left: -2px;
    border: 2px solid #ddd;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 18px;
    padding-top: 9px;
    color: #999;
    margin-left: -13px;
}

        `}
    </style>
  );
}
